// App.jsx
import React, { useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import './css/theme.css'; 

import KeepAliveModal from "./Components/KeepAliveModal";
import useSessionKeepAlive from "./Components/useSessionKeepAlive";
import NotificationAutoAsk from "./Components/NotificationAutoAsk";
import Toolbar from "./Components/Toolbar";
import PageNav from "./Components/PageNav";
import Locations from "./Components/LocationSelector";
import DeviceDashboard from "./Components/DeviceDashboard";
import DeviceControl from "./Pages/DeviceControl";
import FirmwareUploadView from "./Components/FirmwareUploadView";
import LocationMap from "./Components/LocationMap";
import FloorplanViewer from "./Components/FloorplanViewer";
import FloorSelector from "./Components/FloorSelector";
import LoginPage from "./Pages/Login";
import SignupForm from "./Pages/signup";
import User from "./Pages/User";
import { UserDetail } from "./Pages/UserDetail";
import DailyAvgChart from "./Components/DailyAvgChart";

// leaflet 이미지
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import DevicePositionEditor from "./Components/DevicePositionEditor";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// 라우트 보호용(HOC)
function RequireAuth({ children }) {
  const token = localStorage.getItem("accessToken"); // ✅ key 수정
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  const pathname = location.pathname;

  // 상단 UI 표시 여부
  const hideAllPaths = ["/login", "/signup"];
  const showToolbar = !hideAllPaths.includes(pathname);
  const isFloorplan = /^\/floorplan(\/|$)/.test(pathname);
  const showPageNav = showToolbar && !isFloorplan;

const [open, setOpen] = useState(false);
useSessionKeepAlive({
  warnBeforeMs: 15_000,
  autoRefreshIfActive: false, // ⬅️ 테스트 시 자동 리프레시 꺼두고 모달만 뜨게
  onShowModal: () => {
    console.log("[App] onShowModal -> open=true");
    setOpen(true);
  },
  onHideModal: () => {
    console.log("[App] onHideModal -> open=false");
    setOpen(false);
  },
});

  return (
    <>
    <NotificationAutoAsk />
  {/*
     {open && (
  <KeepAliveModal
    onDone={() => { console.log("[App] modal onDone"); setOpen(false); }}
    onCancel={() => { console.log("[App] modal onCancel"); setOpen(false); }}
  />
)}
*/}
      <div className="App">
        {showToolbar && <Toolbar transparent={isFloorplan} decor="zigzag"  />}
 
        <Routes>
          {/* 로그인/회원가입 */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupForm />} />

          {/* 루트 리다이렉트 */}
          <Route
            path="/"
            element={
              <RequireAuth>
                <Navigate to="/locationmap" replace />
              </RequireAuth>
            }
          />

          {/* 보호 라우트 */}
          <Route
            path="/locations"
            element={
              <RequireAuth>
                <Locations />
              </RequireAuth>
            }
          />
          <Route
            path="/locations/:locationName/floors"
            element={
              <RequireAuth>
                <FloorSelector />
              </RequireAuth>
            }
          />
          <Route
            path="/locations/:locationName/floors/:floorName"
            element={
              <RequireAuth>
                <DeviceDashboard />
              </RequireAuth>
            }
          />
             <Route
             path="/floorplan/:locationName/:floorName/edit"
            element={
              <RequireAuth>
             <DevicePositionEditor></DevicePositionEditor>
              </RequireAuth>
            }
          />
          <Route
            path="/control/:deviceId"
            element={
              <RequireAuth>
                <DeviceControl />
              </RequireAuth>
            }
          />
          <Route
            path="/upload"
            element={
              <RequireAuth>
                <FirmwareUploadView />
              </RequireAuth>
            }
          />
          <Route
            path="/locationmap"
            element={
              <RequireAuth>
                <LocationMap />
              </RequireAuth>
            }
          />
          <Route
            path="/floorplan/:locationName/:floorName?"
            element={
              <RequireAuth>
                <FloorplanViewer />
              </RequireAuth>
            }
          />
          <Route
            path="/avgChart"
            element={
              <RequireAuth>
                <DailyAvgChart />
              </RequireAuth>
            }
          />
          <Route
            path="/user"
            element={
              <RequireAuth>
                <User />
              </RequireAuth>
            }
          />
          <Route
            path="/users/:id"
            element={
              <RequireAuth>
                <UserDetail />
              </RequireAuth>
            }
          />
        </Routes>
      </div>
    </>
  );
}

export default function App() {
  return <AppRoutes />;
}
